export default {
  remote: 'simplify_hub_turbopuffer_explorer_mfe',
  name: 'turbopuffer-explorer',
  source: 'https://github.com/telus/simplify-mfe-components',
  urlMapping: {
    'localhost': 'http://localhost:4343/mf-manifest.json',
    'simplify.developers.telus.digital':
      'https://assets.wcpreview.telus.com/1100769639/simplify-turbopuffer-explorer/v1/mf2/mf-manifest.json',
    'simplify.staging.developers.telus.digital':
      'https://assets.wcstage.telus.com/1100769639/simplify-turbopuffer-explorer/v1/mf2/mf-manifest.json',
    'simplify.telus.com':
      'https://assets.telus.com/1100769639/simplify-turbopuffer-explorer/v1/mf2/mf-manifest.json',
  },
};
